import { inject, Injectable, Provider } from '@angular/core';
import { ShortlistMergeChoice, ShortlistMergePrompt } from '@rma/public/compare-agent/private-api/da-compare-agent';
import { RmaModalService } from '@rma/public/generic/ui/modal';
import { from, Observable, switchMap } from 'rxjs';
import type { ShortlistMergeModalComponent, ShortlistMergeModalData } from './ui-shortlist-merge-modal/shortlist-merge-modal.component';

@Injectable()
export class ShortlistMergePromptService implements ShortlistMergePrompt {
  private readonly modalService = inject(RmaModalService);

  public choose(localCodes: string[], apiCodes: string[]): Observable<ShortlistMergeChoice | undefined> {
    return from(import('./ui-shortlist-merge-modal/shortlist-merge-modal.component')).pipe(
      switchMap(({ ShortlistMergeModalComponent: component }) =>
        this.modalService
          .open<ShortlistMergeModalComponent, ShortlistMergeModalData, ShortlistMergeChoice | undefined>(component, {
            data: { localCount: localCodes.length, apiCount: apiCodes.length },
            disableClose: true,
            ariaLabelledBy: 'rma-shortlist-merge-heading',
          })
          .afterClosed(),
      ),
    );
  }
}

export const provideShortlistMergePrompt = (): Provider => ({ provide: ShortlistMergePrompt, useClass: ShortlistMergePromptService });
